import React from 'react'
import {connect} from 'react-redux'
import {getExperienceId} from '../ExperiencesApp/ExperiencesApp'
import {GuidePageViewer} from '../GuidePage/GuidesList/GuidePageViewer'
import * as guidesActions from 'lib/api/experiences/guides'

export class _PrintGuide extends React.PureComponent {
  componentDidMount () {
    const {loadGuides} = this.props
    loadGuides()
  }

  componentDidUpdate (prevProps) {
    const {loadGuides} = this.props
    if (getExperienceId(prevProps) !== getExperienceId(this.props)) {
      loadGuides()
    }
  }

  render () {
    const {guides, guideIds} = this.props

    return (
      <div>
        {guideIds && guideIds.map(id =>
          <div key={id} style={{pageBreakAfter: 'always'}}>
            <h1>{guides.get(id).title}</h1>
            <GuidePageViewer guide={guides.get(id)} />
          </div>
        )}
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const experienceId = getExperienceId(ownProps)

  return {
    loadGuides: () => {
      dispatch(guidesActions.loadGuides(experienceId))
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  const experienceId = getExperienceId(ownProps)
  const gState = state.guides

  return {
    guideIds: gState.getIn(['experienceGuides', experienceId]),
    guides: gState.get('guidePages')
  }
}

export const PrintGuide = connect(
  mapStateToProps,
  mapDispatchToProps
)(_PrintGuide)
